import type { FC, PropsWithChildren } from "react";

import type { Translatable } from "app/pages/sales-intelligence/types";
import { translateNested } from "app/pages/sales-intelligence/utils/common";

import {
    StyledHeaderContainer,
    StyledHeaderContent,
    StyledHeaderContentWrapper,
    StyledHeaderDescription,
    StyledHeaderTitle,
} from "./styles";

type ListPageHeaderProps = {
    title: Readonly<Translatable>;
    description: Readonly<Translatable>;
    titleDataAutomation?: string;
    descriptionDataAutomation?: string;
};

const ListPageHeader: FC<PropsWithChildren<ListPageHeaderProps>> = ({
    title,
    description,
    titleDataAutomation,
    descriptionDataAutomation,
    children,
}) => {
    return (
        <StyledHeaderContainer>
            <StyledHeaderContentWrapper>
                <StyledHeaderTitle data-automation={titleDataAutomation}>{translateNested(title)}</StyledHeaderTitle>
                <StyledHeaderContent>
                    <StyledHeaderDescription data-automation={descriptionDataAutomation}>
                        {translateNested(description)}
                    </StyledHeaderDescription>
                </StyledHeaderContent>
                {children}
            </StyledHeaderContentWrapper>
        </StyledHeaderContainer>
    );
};

export default ListPageHeader;
